module.exports = __webpack_public_path__ + "static/img/多媒体显示屏new.6b1ebf38.png";